import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  showAllCompanies: {
    id: 'views.ChoosenCompanyView.showAllCompanies',
    defaultMessage: 'POKAŻ WSZYSTKIE SPÓŁKI'
  },
  ourSpecialities: {
    id: 'views.ChoosenCompanyView.ourSpecialities',
    defaultMessage: 'W czym się specjalizujemy?'
  },
  ourPartners: {
    id: 'views.ChoosenCompanyView.ourPartners',
    defaultMessage: 'Nasi partnerzy:'
  },
  joinUsQuestion: {
    id: 'views.ChoosenCompanyView.joinUsQuestion',
    defaultMessage: 'Chciałbyś dołączyć do grona naszych partnerów?'
  },
  joinUsLink: {
    id: 'views.ChoosenCompanyView.joinUsLink',
    defaultMessage: 'Dołącz do nas'
  }
});



// WEBPACK FOOTER //
// ./src/views/ChoosenCompany/ChoosenCompanyView.intl.js